export default __webpack_public_path__ + "static/scores@992-07a7b3e9807cbb48e5a09b4126a246b8.webp";